import { useLayoutEffect, useRef, useState } from "react"
import commonStyle from "../../custom/common.module.css"
import textStyle from "../../custom/text.module.css"
import Axios from "axios"

import { useSnackbar } from "consumer/snackbar/provider"
import { get_day_format } from "consumer/@@@/get_day_format"
import Button from "consumer/custom/button"


export default function Verify(props) {

    const verifySet = props['verifySet']
    const sendCheck = props['sendCheck']
    const Set_sendCheck = props['Set_sendCheck']
    const verifyCheck = props['verifyCheck']
    const Set_verifyCheck = props['Set_verifyCheck']

    const [verifyID, Set_verifyID] = useState('')
    const [expireTime, Set_expireTime] = useState('03:00')

    const expireDay = useRef()
    const intervalId = useRef()

    const { add_snackbar } = useSnackbar()

    async function timer(props) {
        const set = props['set']
        const expire_day = props['expire_day']

        if(set === 'start') {
            expireDay.current = expire_day
            intervalId.current = setInterval(() => {
                const expire = new Date(expireDay.current)
                const now = new Date()
                const w = new Date(expire - now)
                const remain_time = `${String(w.getMinutes()).padStart(2, '0')}:${String(w.getSeconds()).padStart(2, '0')}`
                Set_expireTime(remain_time)

                if(Math.floor(w.getTime() / 1000) < 0) {
                    timer({
                        set: 'end'
                    })
                }
            }, 1000)
        }
        else if(set === 'end' || set === 'confirm') {
            clearInterval(intervalId.current)
            Set_expireTime('00:00')

            if(set === 'end') {
                alert('인증 시간이 만료되었습니다.')
                Set_sendCheck(0)
            }
        }
    }

    async function send() {
        if(verifyCheck) {
            alert('이미 인증되었습니다.')
        }
        else {
            const step3 = document.getElementById('step3')
            const student_name = step3.querySelector('[name="student_name"]').value
            const parent_phone = step3.querySelector('[name="parent_phone"]').value

            if(sendCheck) {
                alert('이미 전송되었습니다.')
            }
            else if(student_name.trim() === '') {
                alert('학생 이름을 입력해 주세요.')
            }
            else if(parent_phone.trim() === '') {
                alert('보호자 연락처를 입력해 주세요.')
            }
            else if(window.confirm('전송하시겠습니까?')) {
                const now = new Date()
                const start_day = get_day_format(now)
                now.setMinutes(now.getMinutes() + 3)
                now.setSeconds(now.getSeconds() + 1)
                const expire_day = get_day_format(now)

                await timer({
                    set: 'start',
                    expire_day: expire_day
                })

                const result = await Axios
                                .post("/damo/verify_send", {
                                    verify_set: verifySet,
                                    student_name: student_name,
                                    parent_phone: parent_phone,
                                    start_day: start_day,
                                    expire_day: expire_day
                                })
                const data = result['data']
                console.log(data)
                if(data['status'] === 'success') {
                    await Set_verifyID(data['verify_id'])
                    await Set_sendCheck(1)

                    add_snackbar({
                        'text': '인증번호가 전송되었습니다.'
                    })
                }
                else if(data['status'] === 'fail') {
                    alert(data['message'])
                }
            }
        }
    }

    async function confirm() {
        if(verifyCheck) {
            alert('이미 인증되었습니다.')
        }
        else if(!sendCheck) {
            alert('인증번호를 전송해 주세요.')
        }
        else {
            const step3 = document.getElementById('step3')
            const verify_code = step3.querySelector('[name="verify_code"]').value
            const result = await Axios
                            .post("/damo/verify_confirm", {
                                verify_id: verifyID,
                                verify_code: verify_code
                            })
            const data = result['data']
            alert(data['message'])
            if(data['status'] === 'success') {
                await timer({
                    set: 'confirm'
                })
                await Set_verifyCheck(1)
            }
        }
    }

    return(
        <div className={commonStyle.wrap}>
            <input
                type="text"
                name="verify_id"
                category="field"
                required={true}
                value={verifyID}
                readOnly={true}
                error="문자 인증이 필요합니다."
                style={{
                    display: "none"
                }}
            ></input>

            <label>
                <span style={{color: "blue"}}>문자 인증 </span>
                <span style={{color: "red"}}>{expireTime}</span>
            </label>

            <div
                style={{
                    display: "flex",
                    width: "100%"
                }}
            >
                <Button
                    text="전송"
                    style={{
                        fontSize: "15px",
                        backgroundColor: "black",
                        borderTopRightRadius: "0px",
                        borderBottomRightRadius: "0px",
                    }}
                    event={{
                        onClick: function() {
                            send()
                        }
                    }}
                ></Button>

                <div
                    className={commonStyle.field}
                    style={{
                        borderRadius: "0px"
                    }}
                >
                    <input
                        type="text"
                        className={textStyle.text}
                        name="verify_code"
                        maxLength={20}
                        disabled={verifyCheck ? true : false}
                    ></input>
                </div>

                <Button
                    text="확인"
                    style={{
                        fontSize: "15px",
                        backgroundColor: "black",
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                    }}
                    event={{
                        onClick: function() {
                            confirm()
                        }
                    }}
                ></Button>
            </div>
        </div>
    )
}